import { render, staticRenderFns } from "./VarietyGrowthCreate.vue?vue&type=template&id=58c75299&"
import script from "./VarietyGrowthCreate.vue?vue&type=script&lang=ts&"
export * from "./VarietyGrowthCreate.vue?vue&type=script&lang=ts&"
import style0 from "./VarietyGrowthCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports